import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "776ebvXlMJHp5rtqn8Eyxje", "CommonAmn", undefined);

import { size, tween, Tween, UIOpacity, UITransform, v2, v3, Widget } from "cc";
import { NodeInWindow_Pos } from "../EnumBase";
import { App } from "./App";

var CommonAmn = /*#__PURE__*/function () {
  function CommonAmn() {
    _defineProperty(this, "_initPos_arr", new Map());

    _defineProperty(this, "_exitPos_arr", new Map());
  }

  var _proto = CommonAmn.prototype;

  // LIFE-CYCLE CALLBACKS:
  _proto.onLoad = function onLoad() {};

  _proto.start = function start() {}
  /**获取初始位置 */
  ;

  _proto.getInitPos = function getInitPos(n_cur) {
    return this._initPos_arr.get(n_cur);
  }
  /**初始化位置 */
  ;

  _proto.recordInitPos = function recordInitPos(curNode) {
    this._initPos_arr.set(curNode, v2(curNode.position.x, curNode.position.y));
  };

  _proto.recordInitPosArr = function recordInitPosArr(children) {
    var _this = this;

    children.forEach(function (curChild) {
      _this._initPos_arr.set(curChild, v2(curChild.position.x, curChild.position.y));
    });
  }
  /**弹窗类 -- 有widget组件 */
  ;

  _proto.recordInitPos_Alert = function recordInitPos_Alert(curNode) {
    if (curNode.getComponent(Widget)) {
      curNode.getComponent(Widget).updateAlignment();
    }

    this.recordInitPos(curNode);
  }
  /**记录并设置初始位置 */
  ;

  _proto.recordAndSetInitPos = function recordAndSetInitPos(n_cur, dir) {
    this.recordInitPos(n_cur);
    this.setPosByDir(n_cur, dir);
  }
  /**退出时 坐标 */
  ;

  _proto.recordExitPos = function recordExitPos(curNode, pos) {
    if (pos === void 0) {
      pos = null;
    }

    if (pos) {
      this._exitPos_arr.set(curNode, pos);
    } else {
      this._exitPos_arr.set(curNode, v2(curNode.position.x, curNode.position.y));
    }
  };

  _proto.recordExitPosByType = function recordExitPosByType(curNode, dir) {
    var aimPos = v2();

    if (dir == NodeInWindow_Pos.Top) {
      aimPos = this.getPos_Top(curNode);
    } else if (dir == NodeInWindow_Pos.Bottom) {
      aimPos = this.getPos_Bottom(curNode);
    } else if (dir == NodeInWindow_Pos.Left) {
      aimPos = this.getPos_Left(curNode);
    } else if (dir == NodeInWindow_Pos.Right) {
      aimPos = this.getPos_Right(curNode);
    }

    this._exitPos_arr.set(curNode, aimPos);
  };

  _proto.recordExitPosArr = function recordExitPosArr(children, dir) {
    for (var i = 0; i < children.length; i++) {
      var aimPos = v2();

      if (dir == NodeInWindow_Pos.Top) {
        aimPos = this.getPos_Top(children[i]);
      } else if (dir == NodeInWindow_Pos.Bottom) {
        aimPos = this.getPos_Bottom(children[i]);
      } else if (dir == NodeInWindow_Pos.Left) {
        aimPos = this.getPos_Left(children[i]);
      } else if (dir == NodeInWindow_Pos.Right) {
        aimPos = this.getPos_Right(children[i]);
      }

      this.recordExitPos(children[i], aimPos);
    }
  }
  /**设置节点位置（偏向） */
  ;

  _proto.setPosByDir = function setPosByDir(curNode, dir) {
    var aimPos = v2();

    if (dir == NodeInWindow_Pos.Top) {
      aimPos = this.getPos_Top(curNode);
    } else if (dir == NodeInWindow_Pos.Bottom) {
      aimPos = this.getPos_Bottom(curNode);
    } else if (dir == NodeInWindow_Pos.Left) {
      aimPos = this.getPos_Left(curNode);
    } else if (dir == NodeInWindow_Pos.Right) {
      aimPos = this.getPos_Right(curNode);
    }

    curNode.setPosition(v3(aimPos.x, aimPos.y, 0));
  };

  _proto.setPosByDir_arr = function setPosByDir_arr(nodeArr, dir) {
    for (var i = 0; i < nodeArr.length; i++) {
      this.setPosByDir(nodeArr[i], dir);
    }
  }
  /**边缘放置 */
  ;

  _proto.getPos_Top = function getPos_Top(curNode) {
    var yOffset = App.DataMgr.visibleSize.height - curNode.worldPosition.y;
    return v2(curNode.position.x, yOffset + curNode.position.y + curNode.getComponent(UITransform).height * curNode.getComponent(UITransform).anchorY * curNode.scale.y); // return v2(curNode.position.x, App.DataMgr.visibleSize.height / 2 + curNode.getComponent(UITransform)!.height * curNode.getComponent(UITransform)!.anchorY * curNode.scale.y);
  };

  _proto.getPos_Bottom = function getPos_Bottom(curNode) {
    var h_offset = this.getY_offset();
    var yOffset = -curNode.worldPosition.y - h_offset;
    return v2(curNode.position.x, yOffset + curNode.position.y - curNode.getComponent(UITransform).height * (1 - curNode.getComponent(UITransform).anchorY) * curNode.scale.y);
  };

  _proto.getPos_Left = function getPos_Left(curNode) {
    var w_offset = this.getX_offset();
    var xOffset = -curNode.worldPosition.x - w_offset;
    return v2(xOffset + curNode.position.x - curNode.getComponent(UITransform).width * curNode.scale.x * (1 - curNode.getComponent(UITransform).anchorX), curNode.position.y);
  };

  _proto.getPos_Right = function getPos_Right(curNode) {
    var xOffset = App.DataMgr.visibleSize.width - curNode.worldPosition.x;
    return v2(curNode.position.x + xOffset + curNode.getComponent(UITransform).width * curNode.scale.x * curNode.getComponent(UITransform).anchorX, curNode.position.y);
  };

  _proto.getX_offset = function getX_offset() {
    var designSize = size(750, 1334);
    var visibleSize = App.DataMgr.visibleSize;
    var w_offset = (visibleSize.width - designSize.width) / 2;
    return w_offset;
  };

  _proto.getY_offset = function getY_offset() {
    var designSize = size(750, 1334);
    var visibleSize = App.DataMgr.visibleSize;
    var h_offset = (visibleSize.height - designSize.height) / 2;
    return h_offset;
  }
  /**隐藏节点 - 透明底设置为0 */
  ;

  _proto.hide_opacity_Node = function hide_opacity_Node(curNode, aimO) {
    if (aimO === void 0) {
      aimO = 255;
    }

    curNode.active = false;
    curNode.getComponent;
    curNode.getComponent(UIOpacity).opacity = aimO;
  };

  _proto.show_opacity_Node = function show_opacity_Node(curNode, aimO) {
    curNode.active = true;
    curNode.getComponent(UIOpacity).opacity = aimO;
  }
  /**
   * 运动 - 从屏幕左侧 -》 初始位置
   * @param curNode 移动节点
   * @param dir 初始方向
   * @param dt 延迟时间
   * @param t 运动时间
   * @param easing 运动曲线
   * @param callFunc 回调
   * @param lastCall 最后一个回调
   */
  ;

  _proto.act_dir2Init_node = function act_dir2Init_node(curNode, dir, dt, t, easing, callFunc) {
    if (dt === void 0) {
      dt = 0;
    }

    if (t === void 0) {
      t = 0.4;
    }

    if (easing === void 0) {
      easing = null;
    }

    if (callFunc === void 0) {
      callFunc = null;
    }

    this.setPosByDir(curNode, dir);
    CommonAmn.I.act_entrance(curNode, dt, t, "sineInOut", callFunc);
  };

  _proto.act_dir2Init_nodeArr = function act_dir2Init_nodeArr(nodeArr, dir, dt, t, easing, callFunc, lastCall) {
    if (dt === void 0) {
      dt = 0;
    }

    if (t === void 0) {
      t = 0.4;
    }

    if (easing === void 0) {
      easing = null;
    }

    if (callFunc === void 0) {
      callFunc = null;
    }

    if (lastCall === void 0) {
      lastCall = null;
    }

    var curDt = 0;

    for (var i = 0; i < nodeArr.length; i++) {
      curDt = (i + 1) * dt;

      if (lastCall && i == nodeArr.length - 1) {
        this.act_dir2Init_node(nodeArr[i], dir, curDt, t, easing, lastCall);
      } else {
        this.act_dir2Init_node(nodeArr[i], dir, curDt, t, easing, callFunc);
      }
    }
  }
  /**运动 - 伴随缩放 */
  ;

  _proto.act_dir2InitByScale = function act_dir2InitByScale(n_cur, dir, dt, t, scaleAim, easingAct) {
    Tween.stopAllByTarget(n_cur);
    this.setPosByDir(n_cur, dir);
    n_cur.scale = v3(0, 0, 1);
    var initPos = App.CommonAmn.getInitPos(n_cur);
    tween(n_cur).delay(dt).to(t, {
      position: v3(initPos.x, initPos.y, 0),
      scale: v3(scaleAim, scaleAim, 1)
    }, {
      easing: easingAct
    }).start();
  }
  /**
   * 进入
   * @param curNode 运动节点
   * @param dt: 延迟时间
   * @param t 运动时间
   * @param easing 运动曲线
   * @param callFunc 运动结束回调
   */
  ;

  _proto.act_entrance = function act_entrance(curNode, dt, t, easing, callFunc) {
    if (dt === void 0) {
      dt = 0;
    }

    if (t === void 0) {
      t = 0.4;
    }

    if (easing === void 0) {
      easing = null;
    }

    if (callFunc === void 0) {
      callFunc = null;
    }

    var initPos = this._initPos_arr.get(curNode);

    if (initPos) {
      Tween.stopAllByTarget(curNode);
      tween(curNode).delay(dt).to(t, {
        position: v3(initPos.x, initPos.y, 0)
      }, {
        easing: easing
      }).call(function () {
        if (callFunc) {
          callFunc();
        }
      }).start();
    } else {
      console.error("act_entrance fail  curNode.initPos is not exit ", curNode);
    }
  }
  /**
   * 进入
   * @param curNode 运动节点
   * @param dt: 延迟时间
   * @param t 运动时间
   * @param easing 运动曲线
   * @param callFunc 运动结束回调
   */
  ;

  _proto.act_exit = function act_exit(curNode, dt, t, easing, callFunc) {
    if (dt === void 0) {
      dt = 0;
    }

    if (t === void 0) {
      t = 0.5;
    }

    if (easing === void 0) {
      easing = null;
    }

    if (callFunc === void 0) {
      callFunc = null;
    }

    var exitPos = this._exitPos_arr.get(curNode);

    if (exitPos) {
      tween(curNode).delay(dt).to(t, {
        position: v3(exitPos.x, exitPos.y)
      }, {
        easing: easing
      }).call(function () {
        if (callFunc) {
          callFunc();
        }
      }).start();
    } else {
      console.error("act_exit fail  curNode.exitPos is not exit ", curNode);
    }
  }
  /**
   * 透明度
   * @param curNode 运动节点
   * @param dt: 延迟时间
   * @param t 运动时间
   * @param initO 初始透明度
   * @param aimO 目标透明度
   * @param easing 运动曲线
   * @param callFunc 运动结束回调
   */
  ;

  _proto.act_fade = function act_fade(curNode, dt, t, initO, aimO, curEasing, callFunc) {
    if (dt === void 0) {
      dt = 0;
    }

    if (t === void 0) {
      t = 0.5;
    }

    if (initO === void 0) {
      initO = 0;
    }

    if (aimO === void 0) {
      aimO = 0;
    }

    if (curEasing === void 0) {
      curEasing = null;
    }

    if (callFunc === void 0) {
      callFunc = null;
    }

    if (!curNode.active) {
      curNode.active = true;
    }

    var com_uiOpacity = curNode.getComponent(UIOpacity);

    if (com_uiOpacity) {
      com_uiOpacity.opacity = initO;
      tween(com_uiOpacity).delay(dt).to(t, {
        opacity: aimO
      }, {
        easing: curEasing
      }).call(function () {
        if (callFunc) {
          callFunc();
        }
      }).start();
    } else {
      console.error("act_fade fail  curNode.UIOpacity is not exit ", curNode);
    }
  };

  _proto.act_fadeByActive = function act_fadeByActive(curNode, dt, t, initO, aimO, curEasing, callFunc) {
    if (dt === void 0) {
      dt = 0;
    }

    if (t === void 0) {
      t = 0.5;
    }

    if (initO === void 0) {
      initO = 0;
    }

    if (aimO === void 0) {
      aimO = 0;
    }

    if (curEasing === void 0) {
      curEasing = null;
    }

    if (callFunc === void 0) {
      callFunc = null;
    }

    curNode.active = false;
    tween(curNode).delay(dt).call(function () {
      curNode.active = true;
    }).start();
    var com_uiOpacity = curNode.getComponent(UIOpacity);

    if (com_uiOpacity) {
      com_uiOpacity.opacity = initO;
      tween(com_uiOpacity).delay(dt).to(t, {
        opacity: aimO
      }, {
        easing: curEasing
      }).call(function () {
        if (callFunc) {
          callFunc();
        }
      }).start();
    } else {
      console.error("act_fade fail  curNode.UIOpacity is not exit ", curNode);
    }
  };

  _proto.act_scaleFade = function act_scaleFade(n_cur, dt, t, scale_init, scale_aim, o_init, o_aim, easingAct) {
    if (easingAct === void 0) {
      easingAct = "";
    }

    Tween.stopAllByTarget(n_cur);
    n_cur.scale = v3(scale_init, scale_init, 1);
    tween(n_cur).delay(dt).to(t, {
      scale: v3(scale_aim, scale_aim, 1)
    }, {
      easing: easingAct
    }).start();
    var uiOpacity = n_cur.getComponent(UIOpacity);
    Tween.stopAllByTarget(uiOpacity);
    uiOpacity.opacity = o_init;
    tween(uiOpacity).delay(dt).to(t, {
      opacity: o_aim
    }).start();
  };

  _proto.act_scaleTwice = function act_scaleTwice(n_cur, dt) {
    var curScale = n_cur.scale.x;
    Tween.stopAllByTarget(n_cur);
    tween(n_cur).delay(dt).repeat(3, tween().to(0.05, {
      scale: v3(curScale + 0.015, curScale + 0.015, 1)
    }).to(0.05, {
      scale: v3(curScale, curScale, 1)
    })).start();
  }
  /**
   * 落地 动作
   * @param curNode 运动节点
   */
  ;

  _proto.act_fallGround = function act_fallGround(curNode) {
    var baseScaleX = curNode.scale.x;
    var baseScaleY = curNode.scale.y;
    tween(curNode).to(0.1, {
      scale: v3(baseScaleX * 1.2, baseScaleY * 0.8)
    }, {
      easing: "quadOut"
    }).to(0.1, {
      scale: v3(1.0, 1.0)
    }, {
      easing: "quadIn"
    }).start();
  } // update (dt) {}
  ;

  _createClass(CommonAmn, null, [{
    key: "I",
    get: function get() {
      if (!CommonAmn._I) {
        CommonAmn._I = new CommonAmn();
      }

      return CommonAmn._I;
    }
  }]);

  return CommonAmn;
}();

_defineProperty(CommonAmn, "_I", null);

export { CommonAmn as default };

_cclegacy._RF.pop();